import Icon from '@components/Icon';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { ReactNode } from 'react';

interface Props {
    children?: ReactNode;
    leadingIcon?: string;
    trailingIcon?: string;
    isError?: boolean;
}

function Description(props: Props) {
    const {
        children, leadingIcon, trailingIcon, isError,
    } = props;
    const isText = typeof children === 'string';
    return (<Container isError={isError}>
        {leadingIcon && <Icon name={leadingIcon}/>}
        {isText ? (
            <DescriptionText size='s'
                isError={isError}>
                {children}
            </DescriptionText>
        ) : (<Contents>
            {children}
        </Contents>)}
        {trailingIcon && <Icon name={trailingIcon}/>}
    </Container>);
}

const Container = styled.div<{
    isError?: boolean;
}>`
    align-items: center;
    background-color: ${({ isError }) => (isError ? '#F6DFE2' : 'var(--color-gray1)')};
    border-radius: 8px;
    column-gap: 8px;
    display: flex;
    padding: 12px;
    width: 100%;

    li {
        font-size: 15px;
        line-height: 23px;
        list-style: '•';
        margin-left: 6px;
        padding-left: 6px;
    }
`;

const DescriptionText = styled(Text, {
    shouldForwardProp: (prop) => prop !== 'isError',
})<{
    isError?: boolean;
}>`
    width: 100%;
    color: ${({ isError }) => (isError ? 'var(--color-red)' : 'var(--color-gray8)')};
`;

const Contents = styled.div`
    width: 100%;
    color: var(--color-red);
`;

export default Description;
